<template>
  <el-form ref="elFormRef" :label-width="80" :model="formData" :rules="formRules">
    <el-form-item label="审批结果" prop="status">
      <el-radio-group v-model="formData.status">
        <el-radio :label="WITHDRAWAL_STATUS.PENDING">通过</el-radio>
        <el-radio :label="WITHDRAWAL_STATUS.REJECTED">拒绝</el-radio>
        <el-radio :label="WITHDRAWAL_STATUS.BANK_REJECTED">收款账户问题</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="formData.status === WITHDRAWAL_STATUS.REJECTED" label="拒绝原因" prop="reason">
      <el-input
        v-model="formData.reason"
        clearable
        maxlength="50"
        placeholder="请填写拒绝原因"
        show-word-limit
        type="textarea"
      />
    </el-form-item>
    <el-form-item v-if="formData.status === WITHDRAWAL_STATUS.BANK_REJECTED" label="备注" prop="remark">
      <el-input
        v-model="formData.remark"
        clearable
        maxlength="50"
        placeholder="请填写备注"
        show-word-limit
        type="textarea"
      />
    </el-form-item>
  </el-form>
</template>

<script setup>
  import { ref, reactive, defineProps, defineEmits, defineExpose, getCurrentInstance } from 'vue'
  import { updateRewardStatus } from '@/api/recruitment'
  import { WITHDRAWAL_STATUS } from '../context'

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({}),
    },
  })

  const emit = defineEmits(['success'])

  const formData = reactive({
    groupCode: props.data.groupCode,
    status: '',
    reason: '',
    remark: '',
  })

  const formRules = {
    status: [{ required: true, message: '请选择一项审批结果' }],
    reason: [{ required: true, message: '请填写拒绝原因' }],
  }

  const { proxy } = getCurrentInstance()

  const elFormRef = ref()

  function submit() {
    elFormRef.value.validate((valid) => {
      if (!valid) return

      const { reason, remark, ...params } = formData

      params.reason = params.status === WITHDRAWAL_STATUS.BANK_REJECTED ? remark : reason

      updateRewardStatus(params).then(() => {
        proxy.$baseMessage(`处理成功！`, 'success', 'vab-hey-message-success')
        emit('success')
      })
    })
  }

  defineExpose({
    submit,
  })
</script>

<style lang="scss" scoped></style>
